<template>
	<div class="c col-12 col-sm-6 col-lg-4 col-xl-3">
		<div class="c-specialists__item">
			<div class="c-specialists__item--inner">
				<div class="h4 c-specialists__item--name">{{ getFullName() }}</div>
				<div v-if="resultItem.Function != null" class="c-specialists__item--info">
					<i class="fal fa-file-certificate"></i><span>{{ resultItem.Function }}</span>
				</div>
				<div v-if="resultItem.Region != null" class="c-specialists__item--info">
					<i class="fal fa-map-signs"></i><span>{{ resultItem.Region }}</span>
				</div>
			</div>
			<img
				v-if="resultItem.PhotoOverviewUrl != null && resultItem.PhotoOverviewUrl != '&format=webp'"
				class="c-specialists__item--img"
				:src="resultItem.PhotoOverviewUrl"
				:alt="'Foto ' + getFullName()"
				loading="lazy"
				width="200"
				height="178"
			/>
			<img v-else class="c-specialists__item--img" src="/assets/images/silhouette-200x178.png" :alt="'Foto ' + getFullName()" loading="lazy" width="200" height="178" />
			<div class="c-specialists__item--btn">
				<button type="button" class="btn btn-default" data-modal="open" @click="sendDataLayerEvent('button', '')">
					<i class="fal fa-id-card-alt"></i><span>{{ getTranslation('ContactButton') }}</span>
				</button>
				<div class="c-specialists__modal">
					<div class="c-specialists__modal--backdrop" data-modal="close"></div>
					<div class="c-specialists__modal--inner">
						<button type="button" class="c-specialists__modal--close" data-modal="close" :title="getTranslation('ModalClose')"><i class="fal fa-times"></i></button>
						<div class="c-specialists__modal--head">
							<div class="c-specialists__modal--img">
								<img v-if="resultItem.PhotoModalUrl != null && resultItem.PhotoModalUrl != '&format=webp'" :src="resultItem.PhotoModalUrl" :alt="'Foto ' + getFullName()" loading="lazy" width="320" height="240" />
								<img v-else src="/assets/images/silhouette-640x480.png" :alt="'Foto ' + getFullName()" loading="lazy" width="320" height="240" />
							</div>
							<div class="c-specialists__modal--text">
								<div class="subtitle">{{ getTranslation('ModalContactWith') }}</div>
								<div class="h3 c-specialists__modal--name">{{ getFullName() }}</div>
								<div v-if="resultItem.Function != null" class="c-specialists__modal--info">
									<i class="fal fa-file-certificate"></i><span>{{ resultItem.Function }}</span>
								</div>
								<div v-if="resultItem.Regio != null" class="c-specialists__modal--info">
									<i class="fal fa-map-signs"></i><span>{{ resultItem.Region }}</span>
								</div>
								<div v-if="resultItem.Telephone != null" class="c-specialists__modal--info">
									<i class="fal fa-phone"></i>
									<div class="d-flex" style="gap: 1ch">
										<a :href="'tel: ' + resultItem.Telephone" target="_blank" @click="sendDataLayerEvent('detail', 'Telefoonnummer')">{{ resultItem.Telephone }}</a>
										<template v-if="showWhatsapp()">
											<em>/</em>
											<a :href="'https://wa.me/' + resultItem.Telephone" target="_blank" @click="sendDataLayerEvent('detail', 'Whatsapp')">Whatsapp</a>
										</template>
									</div>
								</div>
								<div v-if="resultItem.Email != null" class="c-specialists__modal--info">
									<i class="fal fa-envelope"></i>
									<a :href="'mailto: ' + resultItem.Email" target="_blank" @click="sendDataLayerEvent('detail', 'E-mailadres')">{{ resultItem.Email }}</a>
								</div>
							</div>
						</div>
						<specialistForm
							:first-name="resultItem.FirstName"
							:full-name="getFullName()"
							:mail="getMail"
							:mail-contact="getMailContact"
							:form-button-text="getTranslation('FormButton')"
							:formfield-name="getTranslation('FormName')"
							:formfield-phone-number="getTranslation('FormPhoneNumber')"
							:intro-title="getTranslation('FormIntroTitle')"
							:intro-text="getTranslation('FormIntroText')"
							:send-title="getTranslation('FormSendTitle')"
							:send-text="getTranslation('FormSendText')"
						/>
						<div class="c-specialists__modal--foot"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import specialistForm from './specialistForm.vue';

export default {
	components: {
		specialistForm
	},
	props: {
		translations: {
			type: String,
			required: true
		},
		resultItem: {
			type: Object,
			required: true
		}
	},
	data() {
		return {};
	},
	computed: {
		getMail() {
			return this.resultItem.Email === null ? '' : this.resultItem.Email;
		},
		getMailContact() {
			return this.resultItem.SpecialistContactEmail === null ? '' : this.resultItem.SpecialistContactEmail;
		}
	},
	methods: {
		getFullName() {
			return this.resultItem.FirstName + ' ' + this.resultItem.LastName;
		},
		showWhatsapp() {
			if (this.resultItem.Telephone.startsWith('06') && this.resultItem.Whatsapp) {
				return true;
			}
			return false;
		},
		getTranslation(key) {
			var allTranslations = JSON.parse(this.translations);
			var translation = allTranslations[key];
			return translation;
		},
		sendDataLayerEvent(trigger, detail) {
			window.dataLayer = window.dataLayer || [];

			switch (trigger) {
				case 'button':
					// eslint-disable-next-line no-case-declarations
					const dataLayerEvent1 = {
						event: 'Contact specialist geopend',
						eventCategory: 'Contact specialist geopend',
						eventAction: 'Contact met specialist geopend',
						eventLabel: this.getFullName()
					};
					window.dataLayer.push(dataLayerEvent1);
					break;
				case 'detail':
					// eslint-disable-next-line no-case-declarations
					const dataLayerEvent2 = {
						event: 'Contact specialist opgenomen',
						eventCategory: 'Contact specialist opgenomen',
						eventAction: detail,
						eventLabel: this.getFullName()
					};
					window.dataLayer.push(dataLayerEvent2);
					break;
			}
		}
	}
};
</script>
